// Markup that Quill 1 cannot represent, so that editing an existing post in
// rich-text mode would silently lose content on save.
//
// Scope here is deliberately narrow. Every rule was checked by pasting the
// markup into the bundled Quill build and diffing what came back:
//
//   <figure class><img></figure>  -> <p><img></p>        image kept
//   <p class="wp-...">            -> <p>                 styling class only
//   <h2 class><strong>            -> <h2><strong>        heading kept
//   <iframe src=youtube>          -> <iframe class=ql-video src=youtube>
//   <a href="">x</a>              -> x                   empty anchor, no content
//   <table><td>a<td>b</table>     -> <p>ab</p>           STRUCTURE DESTROYED
//   <figcaption>text</figcaption> -> text merged into the image paragraph
//
// Only the last two lose anything, so only those are flagged. Flagging the
// others matched all 22 imported posts and forced the whole blog into the
// raw-HTML tab, where no images render at all.
const TABLE_RE = /<\s*table[\s>/]/i;
const FIGCAPTION_RE = /<\s*figcaption[^>]*>([\s\S]*?)<\s*\/\s*figcaption\s*>/i;

const hasText = (html) => !!html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();

export const contentHasRiskyMarkup = (html) => {
  if (!html) return false;
  if (TABLE_RE.test(html)) return true;

  const caption = FIGCAPTION_RE.exec(html);
  return !!caption && hasText(caption[1]);
};
